import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/RootReducer';
import { ActionStatus } from 'store/ActionState';
import { MsEntraIDGroupTargetAccess } from 'gql/MsEntraIDGroupTargetAccess';
import { MsEntraIDGroupTargetAccessState, msEntraIDGroupTargetAccessAdapter } from './MsEntraIDGroupTargetAccessSlice';

const selectSelf = (state: RootState): MsEntraIDGroupTargetAccessState => {
  return state.msEntraIDGroupTargetAccess;
};

const selectMsEntraIDGroupTargetAccessLoading = createSelector(
  selectSelf,
  (state: MsEntraIDGroupTargetAccessState): boolean => {
    return state.loadingState.status === ActionStatus.PROCESSING;
  }
);

const selectMsEntraIDGroupTargetAccesses = createSelector(
  selectSelf,
  (state: MsEntraIDGroupTargetAccessState): MsEntraIDGroupTargetAccess[] => {
    return msEntraIDGroupTargetAccessAdapter.getSelectors().selectAll(state.msEntraIDGroupTargetAccesses);
  }
);

const selectMsEntraIDGroupTargetAccess = (id?: string) => {
  return (state: RootState): MsEntraIDGroupTargetAccess | undefined => {
    return id
      ? msEntraIDGroupTargetAccessAdapter
          .getSelectors()
          .selectById(state.msEntraIDGroupTargetAccess.msEntraIDGroupTargetAccesses, id)
      : undefined;
  };
};

const selectMutationSucceeded = createSelector(selectSelf, (state: MsEntraIDGroupTargetAccessState): boolean => {
  return state.mutationState.status === ActionStatus.SUCCEEDED;
});

const MsEntraIDGroupTargetAccessSelectors = {
  selectMutationSucceeded,
  selectMsEntraIDGroupTargetAccessLoading,
  selectMsEntraIDGroupTargetAccesses,
  selectMsEntraIDGroupTargetAccess,
};

export default MsEntraIDGroupTargetAccessSelectors;
